function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M3 21V16.5H6.85L11.25 12.1V8.375C10.6667 8.175 10.1875 7.8375 9.8125 7.3625C9.4375 6.8875 9.25 6.35 9.25 5.75C9.25 4.98333 9.52083 4.33333 10.0625 3.8C10.6042 3.26667 11.25 3 12 3C12.7667 3 13.4167 3.26667 13.95 3.8C14.4833 4.33333 14.75 4.98333 14.75 5.75C14.75 6.35 14.5625 6.8875 14.1875 7.3625C13.8125 7.8375 13.3333 8.175 12.75 8.375V12.1L17.15 16.5H21V21H16.5V18.1L12 13.6L7.5 18.1V21H3Z",
  fill: "black"
});

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none"
    }, props), _ref)
  );
};

export default __webpack_public_path__ + "static/media/caja.ebb04872.svg";
export { SvgComponent as ReactComponent };